import _ from "lodash";
import { HttpService } from "@/core";
import {
  ProfilePageReq,
  ProfilePageResp,
  ProfileSimpleListReq,
  ProfileDetailResp,
  ProfileReq,
  Cooperation,
  ProjectItem,
} from "./project.interface";

export class ProfileService {
  static usePageApi() {
    const api = (data: ProfilePageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_guarantee_project/page",
        data,
      });
    return HttpService.usePagination<ProfilePageResp>(api);
  }

  static useProjectPageApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/project/guarantee/page",
        data,
      });
    return HttpService.usePagination<any>(api);
  }

  static useSimpleListApi() {
    const api = (data: ProfileSimpleListReq, url = "/maintenance_guarantee_project/list") =>
      HttpService.axios({
        method: "POST",
        url,
        data,
      });
    return HttpService.usePagination<ProjectItem>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance_guarantee_project/detail/${id}`,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ProfileReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_guarantee_project/add",
        data: data,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }
  static useEditApi() {
    const api = (id: string, data: ProfileReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/maintenance_guarantee_project/update/${id}`,
        data: data,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }

  // 当前所勾选状态列表
  static projectStatusList() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: `project/status/list`,
      });
    return HttpService.useRequest<any>(api);
  }

  // 根据项目id查找往来公司
  static useFindCompanyApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "get",
        url: `/project/${id}/lastCompany`,
      });
    return HttpService.useRequest<Cooperation>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/maintenance_guarantee_project/delete/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
